import { __spreadArray } from "tslib";
import { DataType } from './Misc';
import { NumberUtils, Utils } from ".";
//#region Strings
String.prototype.format = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return this.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match;
    });
};
String.prototype.readable = function () {
    var copy = this;
    if (copy.endsWith("Id") || copy.endsWith("ID"))
        copy = copy.substr(0, copy.length - 2);
    var split = copy.replace(/([A-Z]+)/g, ' $1').trim();
    if (split.length) {
        return split[0].toUpperCase() + split.substr(1);
    }
    else {
        return split;
    }
};
//#endregion
//#region Numbers
//Allow comparison to a certain precision.
Number.ignorePrecision = 0.000001;
Number.prototype.compareGT = function CompareGT(y) {
    return this - y > Number.ignorePrecision;
};
Number.prototype.compareGTE = function CompareGTE(y) {
    return this - y > -Number.ignorePrecision;
};
Number.prototype.compareLT = function CompareLT(y) {
    return y.compareGT(this);
};
Number.prototype.compareLTE = function CompareLTE(y) {
    return y.compareGTE(this);
};
Number.prototype.compareE = function CompareE(y) {
    return Math.abs(this - y) < Number.ignorePrecision;
};
Number.prototype.compareNE = function CompareNE(y) {
    return !this.compareE(y);
};
//#endregion
//#region Arrays
Array.prototype.sortBy = function (valueFnOrKey, direction, dataType) {
    if (direction === void 0) { direction = "asc"; }
    var delta = direction === "asc" ? -1 : 1;
    var valueFn;
    var comparer;
    if (valueFnOrKey instanceof Function) {
        valueFn = valueFnOrKey;
        comparer = function (a, b) {
            var aValue = valueFnOrKey(a);
            var bValue = valueFnOrKey(b);
            return aValue < bValue ? delta : (aValue > bValue ? -delta : 0);
        };
    }
    else {
        valueFn = function (item) { return item[valueFnOrKey]; };
        comparer = function (a, b) {
            var aValue = a[valueFnOrKey];
            var bValue = b[valueFnOrKey];
            return aValue < bValue ? delta : (aValue > bValue ? -delta : 0);
        };
    }
    if (dataType === DataType.Decimal) {
        comparer = function (a, b) {
            var aValue = valueFn(a);
            var bValue = valueFn(b);
            if (aValue === null && bValue === null) {
                return 0;
            }
            else if (aValue === null && bValue !== null) {
                return -delta;
            }
            else if (aValue !== null && bValue === null) {
                return delta;
            }
            else {
                return NumberUtils.decimalService.compare(aValue, bValue) * -delta;
            }
        };
    }
    var array = this;
    return Utils.sortableArray(array).sort(comparer);
};
Array.prototype.remove = function (item) {
    var index = this.indexOf(item);
    if (index >= 0) {
        this.splice(index, 1);
    }
};
function getPropertyName(property) {
    if (typeof property === "string") {
        return property;
    }
    else {
        var propertyInfo = property;
        if (property.propertyInfo) {
            propertyInfo = property.propertyInfo;
        }
        return propertyInfo.propertyName;
    }
}
function map(list, property) {
    if (typeof property === "function") {
        return list.map(property);
    }
    else {
        var propertyName_1 = getPropertyName(property);
        return list.map(function (item) { return item[propertyName_1]; });
    }
}
Array.prototype.sum = function (property) {
    if (this.length === 0) {
        return 0;
    }
    var values = map(this, property);
    if (NumberUtils.decimalService.isDecimal(values[0])) {
        return NumberUtils.decimalService.sum(values);
    }
    else {
        return values.reduce(function (total, number) { return total + number; }, 0);
    }
};
Array.prototype.average = function (property) {
    return this.length === 0 ? 0 : this.sum(property) / this.length;
};
Array.prototype.groupBy = function (key, selector) {
    var keyIsFn = typeof key === "function";
    var keyFn = key;
    var keys = this.reduce(function (g, i) {
        var keyValue = keyIsFn ? keyFn(i) : i[key];
        (g[keyValue] = g[keyValue] || []).push(i);
        return g;
    }, {});
    var groupedList = [];
    for (var key_1 in keys) {
        var details = keys[key_1];
        if (selector) {
            groupedList.push(selector(key_1, details[0], details));
        }
        else {
            groupedList.push({ item: details[0], details: details });
        }
    }
    return groupedList;
};
Array.prototype.toDictionary = function (keyFn, valueFn) {
    if (valueFn) {
        return Object.assign.apply(Object, __spreadArray([{}], this.map(function (item) {
            var _a;
            return (_a = {}, _a[keyFn(item)] = valueFn(item), _a);
        }), false));
    }
    else {
        return Object.assign.apply(Object, __spreadArray([{}], this.map(function (item) {
            var _a;
            return (_a = {}, _a[keyFn(item)] = item, _a);
        }), false));
    }
};
//#endregion
Map.prototype.getOrAdd = function (key, valueCallback) {
    var value = this.get(key);
    if (value === undefined) {
        value = valueCallback(key);
        this.set(key, value);
    }
    return value;
};
